import styles from './style.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
// import HistoryLogItem from '../History/historyLogItem';
import ImmutablePropTypes from 'react-immutable-proptypes';


export default class History extends React.Component {
    static propTypes = {
        historyLog: ImmutablePropTypes.list,

        newGame: PropTypes.func.isRequired,
        checkSet: PropTypes.func.isRequired,

    }

    display = () => {
        console.log('In component', JSON.stringify(this.props.historyLog));
        for (let i = 0; i < this.props.historyLog.size; i++) {
            console.log(JSON.stringify(this.props.historyLog.get(i)));
            console.log(JSON.stringify(this.props.historyLog.get(i)._message));

        }

        return this.props.historyLog.map((log, index) => {
            return log.display(index);
        });

    }


    render() {
        // console.log('In componenntntntn');
        return (

            <div className={styles['stretch_container']}>

                <div className={styles['log_container']}>
                    <div className={styles['header']}>
                        <h1>History Log</h1>
                    </div>
                    <div className={styles['gap']} />
                    <div className={styles['history_log']}>
                        {this.display()}
                        <div className={styles['last']} ref={(element) => { this.scrollBottom = element; }} />
                    </div>
                </div>
            </div>

        )
    }
}